module.exports = __webpack_public_path__ + "img/Golden-schwarzeBackground-ganz.eef996fc.jpg";